// components/footer-rsl/index.jsx
/* eslint-disable @next/next/no-img-element */
import Link from "next/link";
import {
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    Link as MLink,
    Stack,
    Typography,
} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
// import GitHubIcon from "@mui/icons-material/GitHub";
import CtaButton from "../buttonWithArrow";

/** ---------- Config that drives the footer ---------- */
export const FOOTER_RSL_CONFIG = {
    heading: "Download RSL Company’s Guideline",
    cta: { label: "Download now", href: "#" },

    contacts: [
        {
            label: "Corporate",
            email: "corporate@royalsmartlimousine.com",
            phone: "+971 4892 4585",
        },
        {
            label: "Franchise",
            email: "franchise@royalsmartlimousine.com",
            phone: "+971 4397 7746",
        },
        {
            label: "Supplier",
            email: "vendor@royalsmartlifestyle.com",
            phone: "+971 4288 5603",
        },
    ],

    about: {
        title: "About RSL",
        text:
            "Royal Smart Limousine is a member of the Rashed Al Jabri Group of Companies. We have been shaping seamless travel experiences since 2002 with our luxury limousine services, Royal Smart Limousine.",
        socials: [
            { icon: "twitter", href: "https://twitter.com/SmartLimousine" },
            { icon: "facebook", href: "https://www.facebook.com/royalsmartlimousine" },
            // { icon: "instagram", href: "https://www.instagram.com/royalsmartlimousine/" },
            { icon: "instagram", href: "https://www.instagram.com/rsl.uae/" },
            { icon: "tiktok", href: "https://www.tiktok.com/@royalsmartlimousine?lang=en" },
        ],
    },


    // linkGroups: [
    //     {
    //         title: "Company",
    //         links: [
    //             { label: "About", href: "/about-rsl" },
    //             { label: "Contact us", href: "/contactUs" },
    //             { label: "Works", href: "#" },
    //             { label: "Career", href: "/careers" },
    //         ],
    //     },
    //     {
    //         title: "Explore",
    //         links: [
    //             { label: "Book A Ride", href: "/carBooking/carBookRide" },
    //             { label: "Investment", href: "/investments/investments" },
    //             { label: "Activities", href: "/activities" },
    //             { label: "Contacts", href: "/contactUs" },
    //         ],
    //     },
    //     {
    //         title: "More",
    //         links: [
    //             { label: "Locate us", href: "/locateUs" },
    //             { label: "Legacy Policy", href: "/legacyandpolicy" },
    //             { label: "Data Privacy Policy", href: "/privacyUrl" },
    //             { label: "Youtube Playlist", href: "#" },
    //         ],
    //     },
    // ],
    linkGroups: [
        {
            title: "Contact",
            links: [
                { label: "Corporate", href: "/contact-us?type=1" },
                { label: "Franchise", href: "/contact-us?type=2" },
                { label: "Supplier", href: "/contact-us?type=3" },
                { label: "Contact Us", href: "/contact-us" }
            ],
        },
        {
            title: "Explore",
            links: [
                { label: "Book A Ride", href: "/carBooking/carBookRide?rideBooking=true" },
                // { label: "Activities", href: "/activities" },
                // { label: "Holidays", href: "/holidays" },
                // { label: "Staycation", href: "/staycations" },
                // { label: "Packages", href: "/packages" },
                { label: "Blogs", href: "/blogs" }
            ],
        },
        {
            title: "More",
            links: [
                { label: "Legacy Policy", href: "/legacyandpolicy" },
                { label: "Locate us", href: "/locateUs" },
                // { label: "Data Privacy Policy", href: "/privacyUrl" },
                // { label: "Terms", href: "/termsAndPolicies" },
                { label: "Location", href: "/location/landing" },
            ],
        },
    ],
};

/** ---------- Footer component ---------- */
export default function FooterRSL({ config = FOOTER_RSL_CONFIG, bgcolor }) {
    return (
        <Box
            component="footer"
            sx={{
                bgcolor: bgcolor ? bgcolor : "#fff",
                // borderTop: "1px solid #eef2f5",
                // padding: y=16px, x=32px (as you asked earlier)
                py: 2,
                px: 4,
            }}
        >
            <Box sx={{ maxWidth: 1200, mx: "auto" }}>
                {/* Top bar: heading + CTA */}
                <Stack
                    direction={{ xs: "column", md: "row" }}
                    alignItems={{ xs: "flex-start", md: "center" }}
                    justifyContent="space-between"
                    spacing={2}
                    sx={{ mb: 2 }}
                >
                    <Typography
                        component="h2"
                        sx={{
                            fontWeight: 600,
                            fontSize: { xs: 22, md: 28 },
                            color: "#0f172a",
                        }}
                    >
                        {config.heading}
                    </Typography>

                    <CtaButton cta={{ label: config.cta?.label || "Download now", href: "/company-profile" }} target="_blank" />
                    {/* <Button
                        component={Link}
                        href={config.cta?.href || "#"}
                        disableElevation
                        sx={{
                            textTransform: "none",
                            fontWeight: 700,
                            px: 2.25,
                            py: 1.5,
                            borderRadius: 9999,
                            color: "#fff",
                            background: "linear-gradient(180deg, #75c4c5 0%, #0d8196 100%)",
                            boxShadow: "0 8px 20px rgba(13,129,150,.25)",
                            "&:hover": {
                                background:
                                    "linear-gradient(180deg, #69babd 0%, #0c788c 100%)",
                                boxShadow: "0 10px 24px rgba(13,129,150,.3)",
                            },
                        }}
                        endIcon={
                            <Box
                                sx={{
                                    ml: 0.5,
                                    width: 26,
                                    height: 26,
                                    borderRadius: "50%",
                                    bgcolor: "#fff",
                                    display: "grid",
                                    placeItems: "center",
                                }}
                            >
                                <ArrowOutwardIcon sx={{ fontSize: 16, color: "#111" }} />
                            </Box>
                        }
                    >
                        {config.cta?.label || "Download now"}
                    </Button> */}
                </Stack>

                <Divider orientation="horizontal" flexItem sx={{ borderColor: "#e6eaee", mx: 0.5, mt: 3, opacity: 1 }} />

                {/* Contact row */}
                <Grid container spacing={4} sx={{ py: 3 }}>
                    {config.contacts.map((c, i) => (
                        <Grid item xs={12} md={4} key={i}>
                            <Typography
                                sx={{ color: "#1aa7a4", fontWeight: 800, mb: 1 }}
                            >
                                {c.label}
                            </Typography>

                            <Stack spacing={0.5}>
                                <MLink
                                    component={Link}
                                    href={`mailto:${c.email}`}
                                    underline="hover"
                                    color="inherit"
                                    sx={{ fontWeight: 700 }}
                                >
                                    {c.email}
                                </MLink>
                                <Typography sx={{ fontWeight: 600 }}>{c.phone}</Typography>
                            </Stack>
                        </Grid>
                    ))}
                </Grid>

                <Divider orientation="horizontal" flexItem sx={{ borderColor: "#e6eaee", mx: 0.5, mt: 2, mb: 2, opacity: 1 }} />

                {/* Bottom columns */}
                <Grid container spacing={4} sx={{ py: 3 }}>
                    {/* About */}
                    <Grid item xs={12} md={4}>
                        <Typography sx={{ fontWeight: 800, mb: 1 }}>
                            {config.about.title}
                        </Typography>
                        <Typography sx={{ color: "text.secondary", mb: 2, fontSize: 14 }}>
                            {config.about.text}
                        </Typography>

                        <Stack direction="row" spacing={1.5}>
                            {config.about.socials?.map((s, idx) => (
                                <IconButton
                                    key={idx}
                                    component={Link}
                                    href={s.href || "#"}
                                    target="_blank"                // 🔥 open in new tab
                                    rel="noopener noreferrer"      // 🔒 security best practice
                                    size="small"
                                    sx={{
                                        // border: "1px solid #e6eaee",
                                        bgcolor: "#fff",
                                        color: '#000',
                                        "&:hover": { bgcolor: "#f6fbfb" },
                                    }}
                                >
                                    {getSocialIcon(s.icon)}
                                </IconButton>
                            ))}
                        </Stack>
                    </Grid>

                    {/* Right side: three equal columns */}
                    <Grid item xs={12} md={8}>
                        <Grid container spacing={4} sx={{ justifyContent: "end" }}>
                            {config.linkGroups.map((g, i) => (
                                <Grid item xs={12} sm={4} md={2.666} key={i}>
                                    <Typography sx={{ fontWeight: 800, mb: 1 }}>
                                        {g.title}
                                    </Typography>
                                    <Stack spacing={1}>
                                        {g.links.map((l, k) => (
                                            <MLink
                                                key={k}
                                                component={Link}
                                                href={l.href || "#"}
                                                underline="none"
                                                color="text.secondary"
                                                sx={{
                                                    "&:hover": { color: "#111" },
                                                    fontSize: 14
                                                }}
                                            >
                                                {l.label}
                                            </MLink>
                                        ))}
                                    </Stack>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>

                <Divider
                    orientation="horizontal"
                    flexItem
                    sx={{ borderColor: "#e6eaee", mx: 0.5, mt: 2, opacity: 1 }}
                />

                <Box
                    sx={{
                        py: 2,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: 13,
                            color: "text.secondary",
                            textAlign: { xs: "center", md: "left" },
                        }}
                    >
                        © {new Date().getFullYear()} Royal Smart Limousine. All rights reserved.
                    </Typography>

                    <Stack
                        direction="row"
                        spacing={2}
                        sx={{ mt: { xs: 1, md: 0 } }}
                    >
                        <MLink
                            component={Link}
                            href="/privacyUrl"
                            underline="none"
                            sx={{ fontSize: 13, color: "text.secondary" }}
                        >
                            Privacy Policy
                        </MLink>
                        <MLink
                            component={Link}
                            href="/termsAndPolicies"
                            underline="none"
                            sx={{ fontSize: 13, color: "text.secondary" }}
                        >
                            Terms & Conditions
                        </MLink>
                    </Stack>
                </Box>

            </Box>
        </Box>
    );
}

/** Small helper to map social names to icons */
function getSocialIcon(name = "") {
    switch (name.toLowerCase()) {
        case "twitter":
            return <TwitterIcon fontSize="small" />;
        case "facebook":
            return <FacebookOutlinedIcon fontSize="small" />;
        case "instagram":
            return <InstagramIcon fontSize="small" />;
        case "tiktok":
            return <img src="/img/tik-tok.png" alt="TikTok" style={{ width: 16, height: 16 }} />;
        default:
            return <TwitterIcon fontSize="small" />;
    }
}
